import { useSetLandlordInactive } from '@services/users/mutations'
import { useTranslation } from 'react-i18next'
import { UserDetail } from 'types/api'

import { Switch } from '@/components/ui/switch'

/** Admin-only label for a landlord who no longer works with SNA. */
export function LandlordInactiveToggle({ landlord }: { landlord: UserDetail }) {
  const { t } = useTranslation('users')
  const { mutate: setInactive, isPending } = useSetLandlordInactive()

  return (
    <label
      className="flex shrink-0 cursor-pointer items-center gap-2 text-sm text-ink"
      title={t('landlordStatus.toggleHint')}
    >
      <Switch
        checked={!!landlord.landlord_inactive}
        disabled={isPending || !landlord.id}
        onCheckedChange={(inactive) =>
          landlord.id && setInactive({ id: landlord.id, inactive })
        }
        aria-label={t('landlordStatus.toggle')}
      />
      {t('landlordStatus.toggle')}
    </label>
  )
}
